module.exports = __webpack_public_path__ + "static/media/microsoft-excel@3x.bfd14a0e.png";